import { MetaImage } from "../components/Layout/Meta";

export const containsHTML = (str: string) => /<[a-z][\s\S]*>/i.test(str);

export const calculateMortgageRepayment = (
  years: number,
  rate: number,
  amount: number
) => {
  if (rate === 0) {
    // console.log("0 rate!!");
    return 0;
  }
  //   if (!years || rate === 0 || !amount) return 0;

  const monthlyInterest = rate / 12 / 100;
  const totalNumofPayments = years * 12;

  const monthlyRepayment =
    (amount *
      monthlyInterest *
      Math.pow(1 + monthlyInterest, totalNumofPayments)) /
    (Math.pow(1 + monthlyInterest, totalNumofPayments) - 1);

  if (!isNaN(monthlyRepayment)) {
    return Math.round(monthlyRepayment).toLocaleString();
  } else {
    return "0";
  }
};

export const hasOnlyNumbers = (str: string) => /^\d+$/.test(str);

export const removeEmptyAttributes = (obj: { [key: string]: unknown }) => {
  return Object.entries(obj).reduce(
    (acc: { [key: string]: unknown }, [key, value]) => {
      if (Array.isArray(value) && value.length === 0) return acc;
      if (!value) return acc;
      acc[key] = value;

      return acc;
    },
    {}
  );
};

export const mapOptionToLabel = (
  values: string[],
  obj: { codename: string; name: string }[]
) => {
  return values
    .map((value) => obj.find((option) => option.codename === value)?.name)
    .join(", ");
};
const filtersMap = [
  { codename: "", name: "By Sector" },
  { codename: "care", name: "Care" },
  { codename: "childcare", name: "Childcare" },
  { codename: "dental_practices", name: "Dental Practices" },
  { codename: "dental", name: "Dental" },
  { codename: "health__medical_", name: "Health (Medical)" },
  { codename: "hotels", name: "Hotels" },
  { codename: "leisure", name: "Leisure" },
  { codename: "pharmacies", name: "Pharmacies" },
  { codename: "pubs", name: "Pubs" },
  { codename: "restaurants", name: "Restaurants" },
  { codename: "pubs_restaurants", name: "Pubs & Restaurants" },
  { codename: "retail", name: "Retail" },
  { codename: "", name: "By Service" },
  { codename: "business_insurance", name: "Business Insurance" },
  { codename: "life_insurance", name: "Life Insurance" },
  { codename: "claims", name: "Claims" },
  { codename: "completed_deals", name: "Completed Deals" },
  { codename: "blog_posts", name: "Blog Posts" },
];

export const getCodenameLabel = (obj: string[]) => {
  if (obj.length === 0) return obj;
  return obj
    .map((tag) => filtersMap.find((item) => item.codename === tag)?.name)
    .filter(Boolean);
};

export const getLabelCodeName = (obj: string[] | undefined) => {
  if (obj?.length === 0) return obj;
  if (Array.isArray(obj)) {
    obj
      .map((label) => filtersMap.find((item) => item.name === label)?.codename)
      .filter(Boolean);
  }
  return;
};

export const generateSectorServiceQueryParams = (
  sectorsObj: string[] | undefined,
  servicesObj: string[] | undefined
) => {
  if (sectorsObj?.length === 0 && servicesObj?.length === 0) return "";

  const sectors = sectorsObj?.length
    ? sectorsObj.map((sector) => `sector=${sector}`).join("&")
    : "";
  const services = servicesObj?.length
    ? servicesObj.map((service) => `service=${service}`).join("&")
    : "";

  return `?${sectors ? sectors : ""}${
    sectors && services ? "&" : ""
  }${services}`;
};

export const hasValidProtocol = (url: string): boolean => {
  const regex = /^https:\/\//;
  return regex.test(url);
};

export const generateHeroImageData = (
  items:
    | Queries.Maybe<readonly Queries.Maybe<Queries.kontent_item>[]>
    | undefined
): MetaImage[] => {
  const heroList = (items ?? []).filter(
    (e) => e?.system?.type == "hero"
  ) as Queries.kontent_item_hero[];
  const images = heroList?.[0]?.elements?.image?.value ?? [];
  return images.map((image) => ({
    src: image?.url ? image?.url + "?w=1000&h=352&auto=format&fit=crop" : "",
    sizes: "100vw",
    srcSet: image?.url
      ? image?.url +
        "?w=1000&h=352&auto=format&fit=crop 1000w," +
        image?.url +
        "?w=768&h=240&auto=format&fit=crop 768w"
      : "",
    description: image?.description ?? "",
  }));
};

/**return the number of existing keys */
export const isObjectEmpty = (obj: Record<string, unknown>) =>
  Object.keys(obj).length === 0;

export function merge_default_values_and_query_params<T extends Object>(
  defaults: T,
  location: Window["location"]
) {
  try {
    const params = new URLSearchParams(location.search);
    return Object.entries(defaults).reduce((acc, [key, val]) => {
      if (params.has(key) && params.get(key) != null) {
        let converted: typeof val = params.get(key) as string;
        if (Array.isArray(val)) {
          converted = params.getAll(key);
        } else if (typeof val === "boolean") {
          const b = params.get(key);
          if (b === "true") {
            converted = true;
          } else {
            converted = false;
          }
        }
        return { ...acc, [key]: converted };
      }

      return acc;
    }, defaults);
  } catch (e) {
    console.log(e);
    return defaults;
  }
}
